import { render, staticRenderFns } from "./offline-banner.vue?vue&type=template&id=5a3381ce&scoped=true&lang=pug&"
import script from "./offline-banner.vue?vue&type=script&lang=js&"
export * from "./offline-banner.vue?vue&type=script&lang=js&"
import style0 from "./offline-banner.vue?vue&type=style&index=0&id=5a3381ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3381ce",
  null
  
)

/* custom blocks */
import block0 from "./offline-banner.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "offline-banner.vue"
export default component.exports